import {PricingModel} from 'src/openapi/admin/models/PricingModel';

import type {
    ContractInfoDto,
    IntegrationContractSpecified,
} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/pricing/typedef';
import type {ContractDetails} from 'src/openapi/admin/models/ContractDetails';
import type {IntegrationContractDetailed} from 'src/openapi/admin/models/IntegrationContractDetailed';
import type {PayPerCallContract} from 'src/openapi/admin/models/PayPerCallContract';
import type {SubscriptionContract} from 'src/openapi/admin/models/SubscriptionContract';

export {getEndDate} from '../contracts/utils';

export const getData = (data: ContractDetails | IntegrationContractDetailed): ContractInfoDto => {
    if (data.contractInfo.pricingModel === PricingModel.INTEGRATION) {
        return data.contractInfo as IntegrationContractSpecified;
    }

    if (data.contractInfo.pricingModel === PricingModel.PAY_PER_CALL) {
        return data.contractInfo as PayPerCallContract;
    }

    return data.contractInfo as SubscriptionContract;
};

export const getOverageCost = (data: ContractDetails | IntegrationContractDetailed): number | null => {
    const contractInfo = data.contractInfo;

    if (contractInfo.pricingModel === PricingModel.SUBSCRIPTION) {
        return (contractInfo as SubscriptionContract).overageCost;
    }

    return null;
};
